import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "./Hero.module.css";
import { usePreloader } from "../../context/PreloaderContext";

// --- 1. Update the import to .mp4 ---
import heroVideo from "../../assets/Videos/DUKAMO.mp4";
import videoThumbnail from "../../assets/Videos/dukamo-thumbnail.jpg";

function Hero() {
  const videoRef = useRef(null);
  const { setVideoLoaded } = usePreloader();

  useEffect(() => {
    // Set initial playback rate for premium feel
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5;
    }

    // --- 💎 APPLE-STYLE PERFORMANCE LOGIC ---
    // Only play the video when it is actually visible in the viewport
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (videoRef.current) {
          if (entry.isIntersecting) {
            videoRef.current.play();
          } else {
            videoRef.current.pause();
          }
        }
      },
      { threshold: 0.1 } // Triggers when at least 10% of the video is visible
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    // Clean up the observer when the component unmounts
    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
      observer.disconnect();
    };
  }, []);

  const handleVideoReady = () => {
    setVideoLoaded(true);
  };

  return (
    <section className={styles.heroSection}>
      <div className={styles.container}>
        <div className={styles.textContent}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.mainTitle}>DUKAMO COFFEE</h1>
            <h2 className={styles.subTitle}>Coffee Elevated.</h2>
            <p className={styles.description}>
              Experience the rich heritage and passion in every cup. Join us in
              a celebration of our land and community.
            </p>
            <Link to="/products" className={styles.ctaButton}>
              Shop Now
            </Link>
          </div>
        </div>

        <div className={styles.videoContent}>
          <div className={styles.videoFrame}>
            <video
              ref={videoRef}
              className={styles.verticalVideo}
              autoPlay
              loop
              muted
              playsInline
              onCanPlayThrough={handleVideoReady}
              poster={videoThumbnail}
            >
              <source src={heroVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
